import axios from "axios";

let _token = null;

export const setToken = (t) => { _token = t; };
export const getToken = () => _token;
export const clearToken = () => { _token = null; };

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL + "/api",
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (_token) {
      config.headers.Authorization = `Bearer ${_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data?.token) {
      _token = response.data.token;
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.startsWith("/login") && window.location.pathname !== "/") {
      _token = null;
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
